import { Component, OnInit } from "@angular/core";
import { DlvAuthOService } from "../../../shared/services/auth0.service";
import { LocalStorageService } from "../../../shared/services/local-storage.service";
import { SettingsConstant } from "../../../shared/constants/settings.constants";
import {
  CanActivate,
  CanLoad,
  Router,
  Route,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from "@angular/router";

// 666 component not in use

@Component({
  selector: "callback-page",
  templateUrl: "./callback.component.html",
  styleUrls : ["./callback.component.scss"]
})
export class DlvCallbackComponent implements OnInit {
  constructor(
    private auth0service: DlvAuthOService,
    public router: Router,
    private localStorage: LocalStorageService
  ) {}

  ngOnInit() {
    
    // 666 can be put somewhere else, but then the component is not in use
    if (this.auth0service.isAuthenticated()) {
      this.router.navigate(["/"]);
    }
    // 666 ends
  }
  
}
